"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HBText = _interopRequireDefault(require("../../HBText/HBText"));
var _HBLinkButton = _interopRequireDefault(require("../../HBLinkButton/HBLinkButton"));
var _colors = _interopRequireDefault(require("../../../styles/colors"));
var HBColorPickerDrawerHeader = function HBColorPickerDrawerHeader(_ref) {
  var onSave = _ref.onSave,
    onClose = _ref.onClose,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Select brand color' : _ref$title,
    testId = _ref.testId;
  return /*#__PURE__*/_react["default"].createElement(Header, {
    role: "banner",
    "aria-labelledby": "".concat(testId, "-title")
  }, /*#__PURE__*/_react["default"].createElement(CancelButton, {
    size: "md",
    testId: "".concat(testId, "-cancel"),
    onClick: onClose,
    textTransform: "uppercase",
    "aria-label": "Cancel"
  }, "CANCEL"), /*#__PURE__*/_react["default"].createElement(Title, {
    type: "emphasis18",
    tag: "h3"
  }, title), /*#__PURE__*/_react["default"].createElement(_HBLinkButton["default"], {
    size: "md",
    testId: "".concat(testId, "-done"),
    linkButtonTheme: "accent",
    onClick: onSave,
    textTransform: "uppercase",
    "aria-label": "Done"
  }, "DONE"));
};
var _default = exports["default"] = HBColorPickerDrawerHeader; // -------------------------------- Styles -------------------------------- //
var Header = _styledComponents["default"].header.withConfig({
  displayName: "HBColorPickerDrawerHeader__Header",
  componentId: "sc-m0qsnp-0"
})(["position:relative;display:flex;justify-content:space-between;align-items:center;width:100%;height:72px;padding:0 16px;background-color:", ";box-shadow:0px 0px 100px 0px rgba(0,0,0,0.5);"], _colors["default"].white);
var Title = (0, _styledComponents["default"])(_HBText["default"]).withConfig({
  displayName: "HBColorPickerDrawerHeader__Title",
  componentId: "sc-m0qsnp-1"
})(["position:absolute;left:50%;transform:translateX(-50%);pointer-events:none;"]);
var CancelButton = (0, _styledComponents["default"])(_HBLinkButton["default"]).withConfig({
  displayName: "HBColorPickerDrawerHeader__CancelButton",
  componentId: "sc-m0qsnp-2"
})(["color:", ";&:hover{color:", ";}"], _colors["default"].neutral700, _colors["default"].neutral900);
//# sourceMappingURL=HBColorPickerDrawerHeader.js.map